import { PageBackgroundModel } from '@sosocio/creator/interfaces';
import ApiService from 'services/ApiService';

class PageBackgroundService extends ApiService<PageBackgroundModel> {
	constructor() {
		super('pagebg');
	}
}

export default new PageBackgroundService();
